import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, withKeys as _withKeys, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-40cfc758"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "py-4" }
const _hoisted_2 = { class: "mb-4 d-flex align-items-center gap-3" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("新增")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("查询")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("重置")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("编辑")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("删除")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_vxe_button = _resolveComponent("vxe-button")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_vxe_column = _resolveComponent("vxe-column")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_vxe_table = _resolveComponent("vxe-table")!
  const _component_vxe_pager = _resolveComponent("vxe-pager")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_tabs, {
      modelValue: _ctx.activeTab,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.activeTab) = $event)),
      onTabChange: _ctx.onTabChange
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_tab_pane, {
          label: "商品合成",
          name: "product"
        }),
        _createVNode(_component_el_tab_pane, {
          label: "卡牌合成",
          name: "card"
        })
      ]),
      _: 1
    }, 8, ["modelValue", "onTabChange"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_vxe_button, {
        type: "button",
        onClick: _ctx.newCompound,
        status: "primary"
      }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }, 8, ["onClick"]),
      _createVNode(_component_el_input, {
        modelValue: _ctx.formData.name,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.name) = $event)),
        placeholder: "商品名称",
        clearable: "",
        style: {"width":"160px"},
        onKeyup: _withKeys(_ctx.onSearch, ["enter"])
      }, null, 8, ["modelValue", "onKeyup"]),
      _createVNode(_component_el_select, {
        modelValue: _ctx.formData.compound_category_id,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.compound_category_id) = $event)),
        placeholder: "分类",
        clearable: "",
        filterable: "",
        style: {"width":"150px"},
        onChange: _ctx.onSearch
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categoryOptions, (cat) => {
            return (_openBlock(), _createBlock(_component_el_option, {
              key: cat.id,
              label: cat.name,
              value: cat.id
            }, null, 8, ["label", "value"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["modelValue", "onChange"]),
      _createVNode(_component_el_select, {
        modelValue: _ctx.formData.enabled,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.enabled) = $event)),
        placeholder: "启用状态",
        clearable: "",
        style: {"width":"120px"},
        onChange: _ctx.onSearch
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_option, {
            label: "启用",
            value: "true"
          }),
          _createVNode(_component_el_option, {
            label: "停用",
            value: "false"
          })
        ]),
        _: 1
      }, 8, ["modelValue", "onChange"]),
      _createVNode(_component_el_button, {
        type: "primary",
        onClick: _ctx.onSearch
      }, {
        default: _withCtx(() => [
          _hoisted_4
        ]),
        _: 1
      }, 8, ["onClick"]),
      _createVNode(_component_el_button, { onClick: _ctx.onReset }, {
        default: _withCtx(() => [
          _hoisted_5
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    _createVNode(_component_vxe_table, {
      data: _ctx.tableData,
      "row-config": { isHover: true }
    }, {
      default: _withCtx(() => [
        _createVNode(_component_vxe_column, {
          field: "id",
          title: "ID",
          width: "60",
          sortable: ""
        }),
        _createVNode(_component_vxe_column, {
          field: "compound_type_display",
          title: "类型",
          width: "60"
        }),
        _createVNode(_component_vxe_column, {
          field: "compound_category_name",
          title: "分类",
          "min-width": "80"
        }),
        _createVNode(_component_vxe_column, {
          field: "product_name",
          title: "商品名称",
          "min-width": "120"
        }),
        _createVNode(_component_vxe_column, {
          field: "price",
          title: "合成价",
          width: "70",
          sortable: ""
        }, {
          default: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(_ctx.formatPrice(row.price)), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_vxe_column, {
          field: "stock",
          title: "库存",
          width: "70",
          sortable: ""
        }),
        _createVNode(_component_vxe_column, {
          field: "compound_qty",
          title: "合成次数",
          width: "80",
          sortable: ""
        }),
        _createVNode(_component_vxe_column, {
          field: "water_need",
          title: "流水",
          width: "60",
          sortable: ""
        }),
        _createVNode(_component_vxe_column, {
          field: "daily_limit",
          title: "日限",
          width: "60",
          sortable: ""
        }),
        _createVNode(_component_vxe_column, {
          field: "sorting",
          title: "排序",
          width: "110",
          sortable: ""
        }, {
          default: _withCtx(({ row }) => [
            _createVNode(_component_el_input_number, {
              modelValue: row.sorting,
              "onUpdate:modelValue": ($event: any) => ((row.sorting) = $event),
              min: 0,
              size: "small",
              "controls-position": "right",
              style: {"width":"90px"},
              onChange: ($event: any) => (_ctx.onSortingChange(row))
            }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])
          ]),
          _: 1
        }),
        _createVNode(_component_vxe_column, {
          field: "enabled_display",
          title: "启用",
          width: "60"
        }),
        _createVNode(_component_vxe_column, {
          field: "updated_at",
          title: "更新时间",
          width: "170",
          sortable: ""
        }),
        _createVNode(_component_vxe_column, {
          field: "updated_by",
          title: "更新人",
          width: "80"
        }),
        _createVNode(_component_vxe_column, {
          title: "操作",
          width: "150",
          fixed: "right"
        }, {
          default: _withCtx(({ row }) => [
            _createVNode(_component_el_button, {
              type: "primary",
              size: "small",
              onClick: ($event: any) => (_ctx.$router.push({ name: 'compound_edit', params: { id: row.id } }))
            }, {
              default: _withCtx(() => [
                _hoisted_6
              ]),
              _: 2
            }, 1032, ["onClick"]),
            _createVNode(_component_el_button, {
              type: "danger",
              size: "small",
              onClick: ($event: any) => (_ctx.onDelete(row.id))
            }, {
              default: _withCtx(() => [
                _hoisted_7
              ]),
              _: 2
            }, 1032, ["onClick"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data"]),
    _createVNode(_component_vxe_pager, {
      "current-page": _ctx.page.currentPage,
      "onUpdate:current-page": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.page.currentPage) = $event)),
      "page-size": _ctx.page.pageSize,
      "onUpdate:page-size": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.page.pageSize) = $event)),
      total: _ctx.page.totalResult,
      layouts: [
        'PrevJump',
        'PrevPage',
        'Number',
        'NextPage',
        'NextJump',
        'Sizes',
        'FullJump',
        'Total',
      ],
      onPageChange: _ctx.onPageChange
    }, null, 8, ["current-page", "page-size", "total", "onPageChange"])
  ]))
}